import React from 'react';
import { trackEvent } from '../utils/metaPixel';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string; // Optional checkout URL
}
export function CTAButton({
  text = 'QUIERO MIS CLASES LISTAS',
  variant = 'primary',
  className = '',
  fullWidth = false,
  size = 'lg',
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    // Track click
    trackEvent('InitiateCheckout');
    if (href) {
      // If href is provided, let the link navigate naturally
      return;
    }
    // Otherwise, smooth scroll to purchase section
    e.preventDefault();
    const section = document.getElementById('purchase-section');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg active:translate-y-0 disabled:opacity-70 disabled:cursor-not-allowed rounded-full';
  const variants = {
    primary: 'bg-[#F97316] hover:bg-[#EA580C] text-white shadow-orange-500/30',
    secondary: 'bg-[#0D9488] hover:bg-[#0F766E] text-white shadow-teal-500/30',
    outline: 'border-2 border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4',
    xl: 'text-xl px-10 py-5'
  };
  const combinedClassName = `
    ${baseStyles}
    ${variants[variant]}
    ${sizes[size]}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  // If href is provided, render as link
  if (href) {
    return <a href={href} onClick={handleClick} className={combinedClassName} data-id="element-229">
        <span data-id="element-230">{text}</span>
        <ArrowRight className="ml-2 w-5 h-5 animate-pulse" data-id="element-231" />
      </a>;
  }
  // Otherwise, render as button with scroll behavior
  return <button onClick={handleClick} className={combinedClassName} data-id="element-232">
      <span data-id="element-233">{text}</span>
      <ArrowRight className="ml-2 w-5 h-5 animate-pulse" data-id="element-234" />
    </button>;
}